var _g, _g2, _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "168px",
    height: "168px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M187.14,425.667H50.607c-28.16,0-51.2-23.04-51.2-51.2c0-28.16,23.04-51.2,51.2-51.2h42.667 c5.12,0,8.533,3.413,8.533,8.533s-3.413,8.533-8.533,8.533H50.607c-18.773,0-34.133,15.36-34.133,34.133 c0,18.773,15.36,34.133,34.133,34.133H187.14c5.12,0,8.533,3.413,8.533,8.533S192.26,425.667,187.14,425.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M76.207,169.667h-25.6c-28.16,0-51.2-23.04-51.2-51.2s23.04-51.2,51.2-51.2h59.733 c5.12,0,8.533,3.413,8.533,8.533c0,5.12-3.413,8.533-8.533,8.533H50.607c-18.773,0-34.133,15.36-34.133,34.133 S31.833,152.6,50.607,152.6h25.6c5.12,0,8.533,3.413,8.533,8.533C84.74,166.253,81.327,169.667,76.207,169.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M178.607,297.667h-34.133c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h34.133 c18.773,0,34.133-15.36,34.133-34.133s-15.36-34.133-34.133-34.133h-25.6c-5.12,0-8.533-3.413-8.533-8.533 c0-5.12,3.413-8.533,8.533-8.533h25.6c28.16,0,51.2,23.04,51.2,51.2S206.767,297.667,178.607,297.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M161.54,84.333c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533 c28.16,0,51.2-23.04,51.2-51.2c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533 C229.807,53.613,199.087,84.333,161.54,84.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M127.407,7.533c-23.893,0-42.667,18.773-42.667,42.667l25.6,452.267L153.007,50.2 C153.007,26.307,151.3,7.533,127.407,7.533"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M118.873,8.387c-2.56-0.853-5.973-0.853-8.533-0.853c-23.893,0-42.667,18.773-42.667,42.667 l42.667,452.267L84.74,50.2C84.74,29.72,99.247,12.653,118.873,8.387"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3bdbb"
    },
    d: "M389.38,502.467h-53.76c-11.947,0-20.48-8.533-20.48-19.627V434.2h93.867v48.64 C409.007,493.933,400.473,502.467,389.38,502.467"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fb6d3"
    },
    d: "M409.007,434.2v48.64c0,11.093-8.533,19.627-19.627,19.627h25.6 c11.093,0,19.627-8.533,19.627-19.627V434.2H409.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a3bdbb"
    },
    d: "M409.007,75.8H315.14V27.16c0-11.093,8.533-19.627,19.627-19.627h53.76 c11.947,0,20.48,8.533,20.48,19.627V75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fb6d3"
    },
    d: "M414.98,7.533h-25.6c11.093,0,19.627,8.533,19.627,19.627V75.8h25.6V27.16 C434.607,16.067,426.073,7.533,414.98,7.533"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    d: "M457.647,434.2H266.5c-11.093,0-19.627-8.533-19.627-19.627V95.427 c0-11.093,8.533-19.627,19.627-19.627h190.293c11.947,0,20.48,8.533,20.48,19.627V413.72 C477.273,425.667,468.74,434.2,457.647,434.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5fb6d3"
    },
    d: "M483.247,75.8h-25.6c11.093,0,19.627,8.533,19.627,19.627V413.72 c0,11.093-8.533,19.627-19.627,19.627h25.6c11.093,0,19.627-8.533,19.627-19.627V95.427C502.873,84.333,494.34,75.8,483.247,75.8"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M483.247,442.733H266.5c-15.36,0-28.16-12.8-28.16-28.16V95.427c0-15.36,12.8-28.16,28.16-28.16h215.893 c15.36,0,28.16,12.8,28.16,28.16V413.72C511.407,429.933,498.607,442.733,483.247,442.733z M266.5,84.333 c-5.973,0-11.093,5.12-11.093,11.093V413.72c0,5.973,5.12,11.093,11.093,11.093h215.893c5.973,0,11.093-5.12,11.093-11.093V95.427 c0.853-5.973-4.267-11.093-10.24-11.093H266.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M414.98,511h-79.36c-15.36,0-28.16-12.8-28.16-28.16v-57.173h136.533v57.173C443.14,498.2,430.34,511,414.98,511z M323.673,442.733v40.107c0,5.973,5.12,11.093,11.093,11.093h79.36c5.973,0,11.093-5.12,11.093-11.093v-40.107H323.673z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M443.14,84.333H306.607V27.16c0-15.36,12.8-28.16,28.16-28.16h79.36c16.213,0,29.013,12.8,29.013,28.16V84.333z M323.673,67.267h102.4V27.16c0-5.973-5.12-11.093-11.093-11.093h-79.36c-6.827,0-11.947,5.12-11.947,11.093V67.267z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 227.253,
    y: 139.8,
    transform: "matrix(-0.8627 0.5058 -0.5058 -0.8627 765.3622 88.8448)",
    width: 286.732,
    height: 17.067
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.533,
    y: 349.089,
    transform: "matrix(-0.8757 0.4828 -0.4828 -0.8757 883.1053 487.9323)",
    width: 282.446,
    height: 17.066
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 366.311,
    y: 122.772,
    transform: "matrix(-0.2576 0.9662 -0.9662 -0.2576 717.8335 -41.4604)",
    width: 17.066,
    height: 264.52
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 299.784,
    y: 173.94,
    transform: "matrix(-0.8609 0.5088 -0.5088 -0.8609 853.9683 131.4608)",
    width: 218.456,
    height: 17.067
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 364.561,
    y: 207.864,
    transform: "matrix(-0.8574 0.5146 -0.5146 -0.8574 927.188 175.9104)",
    width: 149.329,
    height: 17.066
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 428.654,
    y: 242.18,
    transform: "matrix(-0.8478 0.5304 -0.5304 -0.8478 999.1335 214.6391)",
    width: 80.217,
    height: 17.067
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 334.001,
    y: 199.246,
    transform: "matrix(-0.2676 0.9635 -0.9635 -0.2676 722.3737 49.0785)",
    width: 17.066,
    height: 199.674
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 304.651,
    y: 272.267,
    transform: "matrix(-0.2577 0.9662 -0.9662 -0.2577 723.3349 126.2198)",
    width: 17.066,
    height: 137.383
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 277.101,
    y: 338.351,
    transform: "matrix(-0.3162 0.9487 -0.9487 -0.3162 735.3976 227.7076)",
    width: 17.067,
    height: 81.067
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 345.907,
    y: 383.241,
    transform: "matrix(-0.8621 0.5067 -0.5067 -0.8621 999.1491 511.6644)",
    width: 168.103,
    height: 17.066
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 235.77,
    y: 109.914,
    transform: "matrix(-0.874 0.4859 -0.4859 -0.874 664.1005 64.7017)",
    width: 175.784,
    height: 17.066
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.34,511c-4.267,0-7.68-3.413-8.533-7.68L59.14,51.053C59.14,22.04,82.18-1,110.34-1s51.2,23.04,51.2,51.2 l-42.667,453.12C118.02,507.587,114.607,511,110.34,511z M110.34,16.067c-18.773,0-34.133,15.36-34.133,34.133l34.133,361.813 l34.133-362.667C144.473,31.427,129.113,16.067,110.34,16.067z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.34,92.867c-5.12,0-8.533-3.413-8.533-8.533V50.2c0-5.12,3.413-8.533,8.533-8.533s8.533,3.413,8.533,8.533v34.133 C118.873,89.453,115.46,92.867,110.34,92.867z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.207,161.133h-25.6c-28.16,0-51.2-23.04-51.2-51.2s23.04-51.2,51.2-51.2h59.733c5.12,0,8.533,3.413,8.533,8.533 S115.46,75.8,110.34,75.8H50.607c-18.773,0-34.133,15.36-34.133,34.133s15.36,34.133,34.133,34.133h25.6 c5.12,0,8.533,3.413,8.533,8.533C84.74,157.72,81.327,161.133,76.207,161.133z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.073,289.133H135.94c-5.12,0-8.533-3.413-8.533-8.533c0-5.12,3.413-8.533,8.533-8.533h34.133 c18.773,0,34.133-15.36,34.133-34.133s-15.36-34.133-34.133-34.133h-25.6c-5.12,0-8.533-3.413-8.533-8.533 c0-5.12,3.413-8.533,8.533-8.533h25.6c28.16,0,51.2,23.04,51.2,51.2S198.233,289.133,170.073,289.133z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M187.14,417.133H50.607c-28.16,0-51.2-23.04-51.2-51.2s23.04-51.2,51.2-51.2h42.667c5.12,0,8.533,3.413,8.533,8.533 c0,5.12-3.413,8.533-8.533,8.533H50.607c-18.773,0-34.133,15.36-34.133,34.133s15.36,34.133,34.133,34.133H187.14 c5.12,0,8.533,3.413,8.533,8.533C195.673,413.72,192.26,417.133,187.14,417.133z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.007,75.8c-5.12,0-8.533-3.413-8.533-8.533s3.413-8.533,8.533-8.533c28.16,0,51.2-23.04,51.2-51.2 c0-5.12,3.413-8.533,8.533-8.533c5.12,0,8.533,3.413,8.533,8.533C221.273,45.08,190.553,75.8,153.007,75.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPd);
export default __webpack_public_path__ + "static/media/pd.abb0df0c0273aa78f227242c3f333a19.svg";
export { ForwardRef as ReactComponent };